import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useMutation from '../../modules/react/hooks/useMutation';
import FormFieldMediumUploadRow from '../components/FormFieldMediumUploadRow';

export const UPLOAD_MEDIUM = gql`
  mutation MediumUpload($file: Upload!) {
    mediumUpload(file: $file) {
      medium {
        id
        companyId
        filename
        url
        formattedUpdatedAt
        defaultMetadata {
          title
          altText
        }
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {
  activeSection: PropTypes.string.isRequired,
  mediumId: PropTypes.string,
  mediumField: PropTypes.string.isRequired,
  setAppliedMedia: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

const defaultProps = {
  mediumId: undefined,
};

const FormFieldMediumUploadRowContainer = ({
  activeSection,
  mediumId,
  mediumField,
  setAppliedMedia,
  setFieldValue,
  ...rest
}) => {
  const [uploadImage, { loading }] = useMutation(UPLOAD_MEDIUM);

  const [errors, setErrors] = useState();

  const onUpload = async ({ target: { files: [file] } }) => {
    if (!file) { return; }
    setErrors();
    const response = await uploadImage({ variables: { file } });

    if (response.data && response.data.mediumUpload.medium) {
      const uploadedMediumId = response.data.mediumUpload.medium.id;
      setFieldValue(mediumField, uploadedMediumId);
      setAppliedMedia(activeSection,
        { mediumId: uploadedMediumId, ...response.data.mediumUpload.medium });
    } else if (response.data.mediumUpload.userErrors) {
      setErrors(response.data.mediumUpload.userErrors);
    }
  };

  return (
    <FormFieldMediumUploadRow
      {...rest}
      activeSection={activeSection}
      onUpload={onUpload}
      mediumId={mediumId}
      mediumField={mediumField}
      errors={errors}
      setErrors={setErrors}
      loading={loading}
      setFieldValue={setFieldValue}
    />
  );
};

FormFieldMediumUploadRowContainer.propTypes = propTypes;
FormFieldMediumUploadRowContainer.defaultProps = defaultProps;

FormFieldMediumUploadRowContainer.fragments = {};

export default FormFieldMediumUploadRowContainer;
